import { render, staticRenderFns } from "./PostCapture.vue?vue&type=template&id=1b3dfbd6&"
import script from "./PostCapture.vue?vue&type=script&lang=js&"
export * from "./PostCapture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports